<template>
  <div>
    <b-card>
      <modals-container v-model="items" />

      <template>
        <mdb-container>
          <mdb-modal
            :show="confirmar"
            @close="confirmar = false"
            size="sm"
            class="text-center"
            style="top:40px;"
            danger
          >
            <mdb-modal-header center :close="false">
              <p
                class="heading"
              >Confirmar que quieres eliminar la ideologia {{ideologiaSelected.name}}</p>
            </mdb-modal-header>
            <mdb-modal-body>
              <mdb-icon icon="times" size="4x" class="animated rotateIn" />
            </mdb-modal-body>
            <mdb-modal-footer center>
              <mdb-btn outline="danger" @click="eliminar()">Si</mdb-btn>
              <mdb-btn color="danger" @click="confirmar = false">No</mdb-btn>
            </mdb-modal-footer>
          </mdb-modal>
        </mdb-container>
      </template>

      <template>
        <mdb-modal :show="modal" @close="modal = false" fullHeight info removeBackdrop>
          <mdb-modal-header center :close="false">
            <p class="heading lead">{{ modalName}} Geográficos</p>
          </mdb-modal-header>
          <mdb-modal-body class="modal-body">
            <modal-create-ideologia :onClick="closeModalCreate" v-if="modalName=='Crear'"></modal-create-ideologia>
            <modal-edit-ideologia
              :onClick="closeModalCreate"
              :ideologia="ideologiaSelected"
              v-if="modalName=='Editar'"
            ></modal-edit-ideologia>
          </mdb-modal-body>
          <mdb-modal-footer center>
            <mdb-btn outline="danger" @click="modal = false">Cancelar</mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </template>

      <b-btn variant="primary" class="p-2 mb-4" @click="openModal('Crear')">
        <i class="far fa-edit mr-1"></i>
        Nuevo Geográfico
      </b-btn>
      <div slot="header" v-html="caption"></div>
      <b-table
        :dark="dark"
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        responsive="sm"
        :items="items"
        :fields="captions"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="acciones" slot-scope="data">
          <b-row>
            <mdb-dropdown>
              <mdb-dropdown-toggle slot="toggle" outline="primary">Acciones</mdb-dropdown-toggle>
              <mdb-dropdown-menu>
                <mdb-dropdown-item class="mb-2" style="background: #4285f4; color:#fff;" @click="selectIdeologiaEdit(data.item,items)">
                    <i class="far fa-edit mr-1 pl-1" style="color:#fff" ></i>Editar
                </mdb-dropdown-item>
                <mdb-dropdown-item  class="mb-2" style="background: #ff3547; color:#fff;" @click="selectIdeologiaDelete(data.item)" >
                    <i class="far fa-trash-alt mr-1 pl-1" style="color:#fff"></i>Eliminar
                </mdb-dropdown-item>
                <div class="dropdown-divider"></div>
                <mdb-dropdown-item class="mb-2 " style="background: #00c851; color:#fff;"  >
                  Calcular alcance potencial
                </mdb-dropdown-item>
                <mdb-dropdown-item class="mb-2" style="background: #00c851; color:#fff;"  >
                   Añadir todos los CP's por provincia
                </mdb-dropdown-item>
                <mdb-dropdown-item class="mb-2" style="background: #00c851; color:#fff;"  >
                   Añadir todos los CP's por provincia y fila
                </mdb-dropdown-item>
              </mdb-dropdown-menu>
            </mdb-dropdown>
          </b-row>
        </template>
      </b-table>
      <nav>
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        />
      </nav>
    </b-card>
  </div>
</template>

<script>
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";
import ModalCreateIdeologia from "../notifications/ModalCreateIdeologia";
import ModalEditIdeologia from "../notifications/ModalEditIdeologia";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbDropdown,
  mdbDropdownItem,
  mdbDropdownMenu,
  mdbDropdownToggle
} from "mdbvue";
export default {
  name: "table-ideologia",
  inheritAttrs: false,
  components: {
    ModalCreateIdeologia,
    ModalEditIdeologia,
    mdbContainer,
    SemipolarSpinner,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput,
    mdbDropdown,
    mdbDropdownItem,
    mdbDropdownMenu,
    mdbDropdownToggle
  },
  props: {
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 5
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1,
      modal: false,
      modalName: "",
      isLoadingLine: false,
      confirmar: false,
      ideologiaSelected: {}
    };
  },
  computed: {
    items: function() {
      const items = this.tableData;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    }
  },
  methods: {
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount: function() {
      return this.items.length;
    },
    isTrueSelect(acciones) {
      if (acciones) {
        return true;
      }
      return false;
    },
    openModal(opcion) {
      this.modalName = opcion;
      this.modal = true;
    },
    createIdeologia() {
      this.modalName = "Crear";
      this.modal = true;
    },
    selectIdeologiaEdit(item, items) {
      this.ideologiaSelected = item;
      this.modalName = "Editar";
      this.modal = true;
    },
    selectIdeologiaDelete(item) {
      this.ideologiaSelected = item;
      this.modalName = "Eliminar";
      this.confirmar = true;
    },
    closeModalCreate() {
      this.modal = false;
    },
    eliminar() {
      setTimeout(() => {
        store.dispatch("deleteIdeologiaUtility", this.ideologiaSelected.id);
      }, 400);
      store.dispatch("deleteIdeologiaAction", this.ideologiaSelected.id);
      this.confirmar = false;
    }
  }
};
</script>

<style scoped>
.badge {
  cursor: pointer;
}
.modal-body {
  overflow-y: auto;
  height: 400px;
  padding-top: 100px !important;
}
</style>
